import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Table from '@material-ui/core/Table/index';
import TableBody from '@material-ui/core/TableBody/index';
import TableCell from '@material-ui/core/TableCell/index';
import TableHead from '@material-ui/core/TableHead/index';
import TableRow from '@material-ui/core/TableRow/index';
import Paper from '@material-ui/core/Paper/index';

import IconButton from "@material-ui/core/IconButton/index";
import Zoom from "@material-ui/core/Zoom/index";
import Tooltip from "@material-ui/core/Tooltip/index";
import DeleteOutlined from '@material-ui/icons/DeleteOutlined';
import {ReactLocalStorageService} from "../../../../settings/ReactLocalStorageService/ReactLocalStorageService";
import {PopupService} from "../../../../settings/PoPup/PoPup";
import {ProveedorService} from "../../../../services/_Sis/ProveedorService/ProveedorService";
import ModalProveedor from "./ModalProveedor";
import {CONFIG} from "../../../../settings/Config/Config";
import ModalCuentas from "./ModalCuentas";
import {AccountBalance} from "@material-ui/icons";


class ListaTabla extends Component {
	
	Usr = {};
	
	constructor() {
		super();
		this.Usr = ReactLocalStorageService.get('Usr') || {};
	}
	
	eliminar = (item) => {
		let msg = `¿Deseas eliminar el proveedor: ${item.nombre_razon_social.toUpperCase()}?`;
		PopupService.Confirm(['Cancelar', 'Eliminar'], 'warning', CONFIG.titulo_alert_confirm, msg).then((r) => {
			if (r.button === 'Eliminar') {
				ProveedorService.Eliminar(item.id_proveedor).then((response) => {
					this.props.showSnackBars('success', response.mensaje);
					this.props.RefreshList();
				}).catch((error) => {
					this.props.showSnackBars('error', error.mensaje);
				});
			}
		});
	};
	
	render() {
		
		const {lista} = this.props;
		
		return (
			<Paper style={{overflowX: "auto"}}>
				<Table className={'desing-acresco'}>
					<TableHead>
						<TableRow>
							{/*<TableCell component="th" align={'left'}>Id</TableCell>*/}
							<TableCell component="th" align={'left'} className={'padding-20-L padding-20-R'}>Clave</TableCell>
							<TableCell component="th" align={'left'}>Nombre / Razón Social</TableCell>
							<TableCell component="th" align={'left'}>Nombre Comercial</TableCell>
							<TableCell component="th" align={'left'}>RFC</TableCell>
							<TableCell component="th" align={'left'}>Tipo Persona</TableCell>
							<TableCell component="th" align={'left'}>Teléfono</TableCell>
							<TableCell component="th" align={'left'}>Correo Electrónico</TableCell>
							<TableCell component="th" align={'left'}>Dirección</TableCell>
							<TableCell component="th" align={'left'}>Activo</TableCell>
							<TableCell component="th" align={'center'}>Acciones</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{lista.map((item, key) => (
							<TableRow key={key}>
								{/*<TableCell align={'center'}>{item.id_proveedor}</TableCell>*/}
								<TableCell align={'left'} className={'padding-20-L padding-20-R'}>{item.clave}</TableCell>
								<TableCell align={'left'}>{item.nombre_razon_social}</TableCell>
								<TableCell align={'left'}>{item.nombre_comercial}</TableCell>
								<TableCell align={'left'}>{item.rfc}</TableCell>
								<TableCell align={'left'}>{item.tipo_persona}</TableCell>
								<TableCell align={'left'}>{item.telefono}</TableCell>
								<TableCell align={'left'}>{item.correo_electronico}</TableCell>
								<TableCell align={'left'}>{item.direccion}</TableCell>
								<TableCell align={'center'}>
									{Number(item.activo) === 1 ? (
										<div style={{
											width: "50px",
											color: "white",
											borderRadius: "3px",
											padding: "2px 10px",
											background: "darkgreen",
											display: "inline-grid",
										}}>Activo</div>
									) : (
										<div style={{
											width: "50px",
											color: "white",
											borderRadius: "3px",
											padding: "2px 10px",
											background: "#901C30",
											display: "inline-grid",
										}}>Inactivo</div>
									)}
								</TableCell>
								<TableCell align={'center'} className={'padding-5-L padding-5-R'}>
									<div className={'w-auto vertical-inline'}>
										<div className={'v-center'}>
											<ModalCuentas
												tipo={'add'}
												item={item}
												componente={(
													<Tooltip TransitionComponent={Zoom} placement={"top"} title="Cuentas Bancarías">
														<IconButton aria-label="Cuentas Bancarías">
															<AccountBalance/>
														</IconButton>
													</Tooltip>
												)}
												RefreshList={this.props.RefreshList}
												showSnackBars={this.props.showSnackBars}
												ListAreaProyecto={this.props.ListAreaProyecto}
												ListProveedor={this.props.ListProveedor}
												ListBanco={this.props.ListBanco}
												lista={item.cuentas_bancarias}
											/>
										</div>
										
										<div className={'v-center'}>
											<Tooltip TransitionComponent={Zoom} placement={"top"} title="Eliminar">
												<IconButton aria-label="Eliminar"
												            onClick={() => this.eliminar(item)}>
													<DeleteOutlined/>
												</IconButton>
											</Tooltip>
										</div>
										<div className={'v-center'}>
											<ModalProveedor
												tipo={'edit'}
												item={item}
												RefreshList={this.props.RefreshList}
												showSnackBars={this.props.showSnackBars}
												ListBanco={this.props.ListBanco}
												ListAreaProyecto={this.props.ListAreaProyecto}
											/>
										</div>
										<div className={'v-center'}>
											<ModalProveedor
												tipo={'view'}
												item={item}
												RefreshList={this.props.RefreshList}
												showSnackBars={this.props.showSnackBars}
												ListBanco={this.props.ListBanco}
												ListAreaProyecto={this.props.ListAreaProyecto}
											/>
										</div>
									</div>
								</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			</Paper>
		)
	}
}

ListaTabla.propTypes = {
	lista: PropTypes.array.isRequired,
	RefreshList: PropTypes.func.isRequired,
	showSnackBars: PropTypes.func.isRequired,
	ListProveedor: PropTypes.func.isRequired,
	ListBanco: PropTypes.func.isRequired,
	ListAreaProyecto: PropTypes.func.isRequired,
};

export default ListaTabla;
